<template>
  <div class="container">
    <div class="row row-cols-1 row-cols-md-3 mb-3 text-center system-list">
      <div
        class="col"
        v-for="(systemCard, index) in systemCardList"
        :key="index"
      >
        <div class="card mb-4 rounded-3 shadow-sm">
          <div class="card-header py-3">
            <h4 class="my-0 fw-normal">
              {{ systemCard.fullName }}
            </h4>
          </div>
          <div class="card-body">
            <h3 class="card-title pricing-card-title">
              {{ systemCard.shortName }}
            </h3>
            <ul class="list-unstyled mt-3 mb-4">
              <li
                v-for="(pointer, pointerIndex) in systemCard.pointers"
                :key="pointerIndex"
              >
                <input
                  class="form-check-input me-1"
                  type="checkbox"
                  :value="`${pointer}-${pointerIndex}`"
                  :aria-label="`${pointer}-${pointerIndex}`"
                  checked
                />
                {{ pointer }}
              </li>
            </ul>
            <button
              type="button"
              class="w-100 btn btn-lg btn-primary"
              @click="changeSystem(systemCard.shortName)"
            >
              {{ systemCard.buttonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TheBody",
  methods: {
    changeSystem(systemUrl) {
      this.$router.push({ name: systemUrl });
    },
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters(["systemCardList"]),
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
